import { LearningStatus } from '@/core/domain/resources/enums/LearningStatus'
import type { ILearningGrainURLOptions } from '@/core/domain/learning/grain/ILearningGrainURLOptions.ts'

export class LearningGrainURLOptions implements ILearningGrainURLOptions {
  withSupports?: boolean
  withQuiz?: boolean
  status?: LearningStatus.Values[]

  constructor(obj: ILearningGrainURLOptions) {
    // Handle hierarchical dependencies
    this.withQuiz = obj.withQuiz // Independent from other parameters

    // If withSupports is true, both withGrains and withModules must be true
    this.withSupports = obj.withSupports

    this.status = obj.status
  }

  getUrlOptions(): string {
    const params = new URLSearchParams()

    // withTask is always added because it's independent
    params.append('withQuiz', String(!!this.withQuiz))

    params.append('withSupports', String(!!this.withSupports))

    // Always add status if it exists
    if (this.status && this.status.length > 0) {
      params.append('status', this.status.join(','))
    }

    return `?${params.toString()}`
  }

  // Utility method to normalize options according to dependency rules
  static normalizeOptions(options: ILearningGrainURLOptions): ILearningGrainURLOptions {
    // Apply dependency rules

    return { ...options }
  }
}
